module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_MicrophoneOff_16"],"path":[{"$":{"d":"M11,7.28,5.34,1.65A3,3,0,0,1,11,3V7C11,7.1,11,7.19,11,7.28ZM5,7a3,3,0,0,0,3,3l.28,0L5,6.69Zm8.6,0H12.4a4.34,4.34,0,0,1-.26,1.45l.93.93A5.56,5.56,0,0,0,13.6,7ZM9,14V12.51a5.54,5.54,0,0,0,1.38-.44l-.93-.93A4.35,4.35,0,0,1,8,11.4,4.41,4.41,0,0,1,3.6,7H2.4A5.61,5.61,0,0,0,7,12.51V14H4v2h8V14Zm6.25,1,.71-.71-.71.71Zm-3-4.37-.87-.87-1-1L5,3.29,1.77.06,1.06.77,5,4.71,9.73,9.44l1,1,.86.86L15.25,15l.71-.71Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_MicrophoneOff_16.svg
// module id = qJzd
// module chunks = 1